import { computed, ref } from 'vue'
import useAppState, { ViewType } from '@/composables/ui/ui'
import useLocalStorageManager, {
  LS_NAMES,
} from '@/composables/localStorage/localStorageManager'

export enum ActivePostPage {
  Newest = 'PostNewestList',
  Oldest = 'PostOldestList',
  Best = 'PostBestList',
  Show = 'PostShowList',
  TOP_NEWEST = 'PostTopNewestList',
}

const POST_PAGE_TO_CACHE = [
  ActivePostPage.Newest,
  ActivePostPage.Oldest,
  ActivePostPage.Best,
]

const { getItem, setItem } = useLocalStorageManager()

// eslint-disable-next-line @typescript-eslint/no-use-before-define
const activePage = ref<ActivePostPage>(getDefaultPostListMenu())

function updateDefaultPostListMenuCache() {
  if (POST_PAGE_TO_CACHE.includes(activePage.value)) {
    setItem(LS_NAMES.DEFAULT_POST_LIST_ORDER, activePage.value)
  }
}

function getDefaultPostListMenu() {
  const cachedItem = getItem(LS_NAMES.DEFAULT_POST_LIST_ORDER)

  if (cachedItem) {
    for (const activePostPage of POST_PAGE_TO_CACHE) {
      if (activePostPage === cachedItem) {
        return activePostPage
      }
    }
  }

  return ActivePostPage.Oldest
}

export function usePostListMenuCache() {
  return {
    updateDefaultPostListMenuCache,
  }
}

export default function usePostListMenu() {
  const isNewest = computed(() => {
    return activePage.value === ActivePostPage.Newest
  })

  const isOldest = computed(() => {
    return (
      activePage.value === ActivePostPage.Oldest ||
      activePage.value === ActivePostPage.Show
    )
  })

  const isBest = computed(() => {
    return activePage.value === ActivePostPage.Best
  })

  const init = () => {
    const { viewType } = useAppState()

    if (viewType.value === ViewType.TOP_NEWEST) {
      activePage.value = ActivePostPage.TOP_NEWEST
    }
  }

  const reset = () => {
    activePage.value = getDefaultPostListMenu()
  }

  init()

  return {
    activePage,
    isNewest,
    isOldest,
    isBest,
    reset,
  }
}
